<template>
    <div class="au-page-header">
        <div>
            <h1 class="au-page-title">{{ title }}</h1>
            <p v-if="subtitle" class="au-page-subtitle">{{ subtitle }}</p>
        </div>
        <div v-if="$slots.actions" class="d-flex gap-2 flex-wrap">
            <slot name="actions"></slot>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "PageHeader",
    props: {
        title: { type: String, required: true },
        subtitle: { type: String, default: "" },
    },
});
</script>
